import { render, staticRenderFns } from "./BalanceStatement-us.vue?vue&type=template&id=4066fe72&scoped=true"
import script from "./BalanceStatement-us.vue?vue&type=script&lang=js"
export * from "./BalanceStatement-us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066fe72",
  null
  
)

export default component.exports